import Index from './Index';
import SettingsContent from '../Wrapper';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN.ONGOING.HEADER',
        icon: 'arrow-swap',
      },
      children: [
        {
          path: '',
          redirect: 'whatsapp',
        },
      ],      
    },
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: { template: '<router-view />' },
      children: [
        {
          path: 'whatsapp',
          name: 'whatsapp',
          roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
          component: { ...Index },
          accountTypes: ['account', 'subaccount', 'parent_account']
        },
      ],      
    },
  ],
};
